import { apiClient } from './api'
import type { ApiResponse } from '@/types/common'

export interface SMTPConfig {
  host: string
  port: number
  user: string
  password: string
  fromEmail: string
  fromName: string
}

export interface UpdateSMTPConfigPayload {
  host?: string
  port?: number
  user?: string
  password?: string
  fromEmail?: string
  fromName?: string
}

export const smtpService = {
  getSMTPConfig: async (): Promise<ApiResponse<SMTPConfig>> => {
    return apiClient.get<SMTPConfig>('/admin/smtp')
  },

  updateSMTPConfig: async (payload: UpdateSMTPConfigPayload): Promise<ApiResponse<{ message: string }>> => {
    return apiClient.put<{ message: string }>('/admin/smtp', payload)
  },

  testSMTPConfig: async (): Promise<ApiResponse<{ message: string }>> => {
    return apiClient.post<{ message: string }>('/admin/smtp/test')
  },
}
